export default __webpack_public_path__ + "static/media/gum2.a72305ee.png";